import FinancesSuccessView from 'components/organisms/finances-success/FinancesSuccessView'
import React from 'react'

const MonthlySuccess = () => {
  return (
    <FinancesSuccessView />
  )
}

export default MonthlySuccess